export const paymentsURL = '/external-accounts-settings/payment-account';
export const accessControlURL =
  '/external-accounts-settings/access-control-account';
export const camerasURL = '/external-accounts-settings/camera-account';
export const customIntegrationsURL =
  '/external-accounts-settings/custom-integrations';

export const ACCOUNT_TYPE = {
  external_payments: 'external-payments-accounts',
  aptexx: 'aptexx',
  brivo: 'brivo',
  clickpay: 'clickpay',
  comelit: 'comelit',
  eagleeye: 'eagleeye',
  smartair: 'smartair',
  two_n: '2n',
  akuvox: 'akuvox',
  bmx: 'bmx',
  dormakaba: 'dormakaba',
  lyazon: 'lyazon',
  zerv: 'zerv',
  salto: 'salto',
  keyscan: 'keyscan',
};

export const CARDS_INFO = [
  {
    cardTitle: 'Payments Accounts',
    links: [
      {
        title: 'Aptexx Accounts',
        url: `${paymentsURL}/aptexx`,
      },
      {
        title: 'Clickpay Accounts',
        url: `${paymentsURL}/clickpay`,
      },
      {
        title: 'External Accounts',
        url: `${paymentsURL}/external`,
      },
    ],
  },
  {
    cardTitle: 'Access Control Accounts',
    links: [
      {
        title: 'Brivo Accounts',
        url: `${accessControlURL}/brivo`,
      },
      {
        title: 'Smartair Accounts',
        url: `${accessControlURL}/smartair`,
      },
      {
        title: 'Comelit Accounts',
        url: `${accessControlURL}/comelit`,
      },
      {
        title: '2N Accounts',
        url: `${accessControlURL}/two-n`,
      },
      {
        title: 'Akuvox Accounts',
        url: `${accessControlURL}/akuvox`,
      },
      {
        title: 'BMX Accounts',
        url: `${accessControlURL}/bmx`,
      },
      {
        title: 'Dormakaba Accounts',
        url: `${accessControlURL}/dormakaba`,
      },
      {
        title: 'Lyazon Accounts',
        url: `${accessControlURL}/lyazon`,
      },
      {
        title: 'Zerv Accounts',
        url: `${accessControlURL}/zerv`,
      },
      {
        title: 'Salto Accounts',
        url: `${accessControlURL}/salto`,
      },
      {
        title: 'Keyscan Accounts',
        url: `${accessControlURL}/keyscan`,
      },
    ],
  },
  {
    cardTitle: 'Cameras Accounts',
    links: [
      {
        title: 'EE Accounts',
        url: `${camerasURL}/eagle-eye`,
      },
    ],
  },
  {
    cardTitle: 'Custom Integrations',
    links: [
      {
        title: 'Custom external links',
        url: `${customIntegrationsURL}/external-links`,
      },
    ],
  },
];

export const intercomButtonLevelOptions = [
  { value: 'unit', label: 'Unit name (1A)' },
  {
    value: 'unit_resident_initials',
    label: 'Unit name - Resident initials (1A - M. S.)',
  },
  {
    value: 'unit_resident_full_last_name',
    label: 'Unit name - Resident first initial + last name (1A - M. Smith)',
  },
  {
    value: 'unit_last_name_first_initial',
    label: 'Unit name - Resident last name + first initial (1A - Smith M.)',
  },
  {
    value: 'resident_full_last_name',
    label: 'Resident first initial + last name (M. Smith)',
  },
  {
    value: 'resident_full_last_name_ln_first',
    label: 'Resident last name + first initial (Smith M.)',
  },
  {
    value: 'full_first_name_last_initial',
    label: 'Resident first name + last initial (Mike S.)',
  },
];

export const duplicatesResolutionMethods = [
  {
    value: 'minimum_required_letters',
    label: 'Use minimum required letters',
  },
  {
    value: 'full_name',
    label: 'Use full name',
  },
];

export const OPENING_METHOD = {
  BRIVO: [{ label: 'Online', value: 'online' }],
  SMARTAIR: [
    { label: 'All', value: 'all' },
    { label: 'Online', value: 'online' },
    { label: 'Bluetooth', value: 'bt' },
  ],
  COMELIT: [{ label: 'Online', value: 'online' }],
  TWO_N: [{ label: 'Online', value: 'online' }],
  AKUVOX: [{ label: 'Online', value: 'online' }],
  BMX: [{ label: 'Online', value: 'online' }],
  DORMAKABA: [{ label: 'Bluetooth', value: 'bt' }],
  LYAZON: [{ label: 'Bluetooth', value: 'bt' }],
  ZERV: [{ label: 'Online', value: 'online' }],
  SALTO: [
    { label: 'All', value: 'all' },
    { label: 'Online', value: 'online' },
    { label: 'Bluetooth', value: 'bt' },
  ],
  KEYSCAN: [
    { label: 'All', value: 'all' },
    { label: 'Online', value: 'online' },
    { label: 'Bluetooth', value: 'bt' },
  ],
};
